// Fichas de modelado desde hub-api. El estudio y la tienda leen la misma fuente.
import { hubGet, hubPost } from './hub';

export async function cargarFichasHub() {
  const r = await hubGet('fichas');
  if (!r || r.ok === false) throw new Error(r?.motivo || 'fichas no disponibles');
  return {
    panels: Array.isArray(r.panels) ? r.panels : [],
    inverters: Array.isArray(r.inverters) ? r.inverters : [],
    batteries: Array.isArray(r.batteries) ? r.batteries : [],
    otros: Array.isArray(r.otros) ? r.otros : [],
    total: r.total || 0,
  };
}

export async function chatearAlex(pregunta, historial = [], extras = {}) {
  return hubPost('alex/chat', {
    pregunta,
    historial,
    nombre: extras.nombre,
    sso: extras.sso,
  });
}
